import React from 'react';
import data from './../data/data';
import Resizer from './Resizer.js';
import Teams from './Teams.js';
import Drawer from './Drawer.js';
import SortButton from './SortButton.js';
import BallButton from './BallButton.js';
import ImageLoader from 'react-imageloader';
import AppConstants from './../constants/AppConstants';
import AppDispatcher from './../dispatcher/AppDispatcher';
import ResizerStore from './../stores/ResizerStore';
import TeamsStore from './../stores/TeamsStore';
import mathHelper from './../helpers/math';


/**
 * NBAAllStarReconfigure component
 * The top level component for the app
 * @class
 */
const NBAAllStarReconfigure = React.createClass({
  imagePath: 'assets/image/players',
  displayName: 'NBAAllStarReconfigure',
  showSortImageTimeout: 0,
  windowScrollY: 0,
  previousWindowScrollY: 0,
  pressed: false,
  pressMoved: false,
  descriptionHidden: false,


  propTypes: {
    touch: React.PropTypes.bool.isRequired,
    supportsCssTransforms3d: React.PropTypes.bool.isRequired,
    isIOS: React.PropTypes.bool,
    shareData: React.PropTypes.object.isRequired,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      coverCardBounds: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
      },
      windowSize: {
        width: 0,
        height: 0,
      },
      inIntro: true,
      animateOutInfoHeader: true,
      showContent: false,
      showInfo: false,
      showCover: false,
      animateCoverBall: false,
      animateCoverCta: false,
      animateCoverPlayers: false,
      sortImage: null,
      showDescription: true,
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    TeamsStore.addChangeListener(this._onTeamsChange);
    ResizerStore.addChangeListener(this._onResizerChange);

    AppDispatcher.handleViewAction({
      actionType: AppConstants.SET_CATEGORY,
      category: data.categories[0],
    });

    this.randomPLayerInts = [
      mathHelper.getRandomInt(17, 23),
      mathHelper.getRandomInt(0, 5),
      mathHelper.getRandomInt(6, 11),
      mathHelper.getRandomInt(12, 17),
    ];

    this._onResizerChange();
    this._doIntro();
  },


  /**
   * Called right before component unmounts from DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    TeamsStore.removeChangeListener(this._onTeamsChange);
    ResizerStore.removeChangeListener(this._onResizerChange);
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    const coverCard = this.state.inIntro ? this._renderCoverCard() : null;
    const sortInfo = this._renderSortInfo();
    const showContentClass = this.state.showContent ? ' show' : '';
    const showHeaderClass = this.state.inIntro ? '' : ' show-header';
    const teamsState = TeamsStore.getState();
    const team1RowsClass = ' team-1-rows-' + teamsState.team1Rows;
    const maxPlayersClass = ' max-player-count-' + teamsState.maxPlayerCount;
    const evenRowsClass = teamsState.teamsEvenRows ? ' even-rows' : ' uneven-rows';
    const showDescriptionClass = this.state.showDescription ?
      ' show-description' : '';
    const wrapperClass = 'wrapper' +
      showContentClass +
      showHeaderClass +
      team1RowsClass +
      evenRowsClass +
      maxPlayersClass +
      showDescriptionClass;

    return (React.createElement("div", {className: "component-nba-all-star-reconfigure"}, 
      React.createElement(Resizer, {useOrientation: this.props.touch}), 
      React.createElement("div", {className: wrapperClass}, 
        React.createElement("div", {className: "content"}, 
          React.createElement("div", {className: "header main"}, 
            React.createElement("a", {className: "logo", href: "http://bleacherreport.com/"}, 
              React.createElement("img", {src: "assets/image/logo/br-logo.png"})
            ), 
            React.createElement("div", {className: "description"}, "The East/West All-Star Team configuration has grown tired—neither players nor fans put much stock into the outcome. It's high time to re-think the format. Here are some ideas, not all of which are good."), 
            React.createElement("a", {
              onClick: this._openPopup, 
              href: 'http://www.facebook.com/sharer/sharer.php?s=100&p[url]=' +
                encodeURI(window.location.href) +
                '&p[title]=' + encodeURI(this.props.shareData.title) +
                '&p[summary]=' + encodeURI(this.props.shareData.summary), 
              
              title: "share on facebook", 
              target: "_blank", 
              className: "social facebook"
            }, 
              React.createElement("img", {src: "assets/image/icon/facebook-icon.png"})
            ), 
            React.createElement("a", {
              onClick: this._openPopup, 
              href: 'https://twitter.com/share?text=' +
                this.props.shareData.summary + '&url=' +
                encodeURIComponent(window.location.href), 
              
              title: "share on twitter", 
              target: "_blank", 
              className: "social twitter"
            }, 
              React.createElement("img", {src: "assets/image/icon/twitter-icon.png"})
            )
          ), 
          React.createElement(Teams, {
            isIOS: this.props.isIOS, 
            imagePath: this.imagePath, 
            touch: this.props.touch, 
            data: data.players, 
            categoryData: data.categories, 
            supportsCssTransforms3d: this.props.supportsCssTransforms3d}
          ), 
          React.createElement("div", {className: "sort-button-wrapper"}, 
            React.createElement(SortButton, {
              ref: "sortButton", 
              isIOS: this.props.isIOS, 
              touch: this.props.touch, 
              data: data.categories}
            )
          )
        )
      ), 
      React.createElement("div", {
        className: "sort-hit-area", 
        onTouchStart: this.props.touch ? this._onHitAreaTouchStart : null, 
        onTouchMove: this.props.touch ? this._onHitAreaTouchMove : null, 
        onMouseDown: !this.props.touch ? this._onHitAreaTouchStart : null, 
        onTouchEnd: this.props.touch ? this._onHitAreaTouchEnd : null, 
        onMouseUp: !this.props.touch ? this._onHitAreaTouchEnd : null}
      ), 
      sortInfo, 
      coverCard
    ));
  },


  /**
   * Called when the hit area is pressed
   * @returns {undefined} undefined
   */
  _onHitAreaTouchStart() {
    this.pressed = true;
    this.refs.sortButton._onPress();
  },


  /**
   * Called when the hit area is pressed
   * @returns {undefined} undefined
   */
  _onHitAreaTouchMove() {
    this.pressMoved = true;

    this.refs.sortButton._releaseWithoutSort();
  },


  /**
   * Called when the hit area is released
   * @returns {undefined} undefined
   */
  _onHitAreaTouchEnd() {
    if (!this.pressMoved) {
      this.refs.sortButton._onRelease();
    }

    this.pressed = false;
    this.pressMoved = false;
  },


  /**
   * Opens a popup window
   * @returns {undefined} undefined
   */
  _openPopup(e) {
    const target = e.currentTarget;
    const url = target.getAttribute('href');

    window.open(url, 'Share', 'width=600, height=500');

    e.stopPropagation();
    e.preventDefault();
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  _renderCoverCard() {
    const randomInts = this.randomPLayerInts;
    const playersImages = randomInts ? this._renderPlayerImages() : null;
    const actionText = this.props.touch ? 'Tap' : 'Click';
    const showClass = this.state.showCover ? ' show' : '';
    const animateBallClass = this.state.animateCoverBall ? ' animate-ball' : '';
    const animateCtaClass = this.state.animateCoverCta ? ' animate-cta' : '';
    const animatePlayersClass = this.state.animateCoverPlayers ?
      ' animate-players' : '';
    const className = 'cover-card' +
      showClass +
      animateBallClass +
      animateCtaClass +
      animatePlayersClass;

    return (React.createElement(Drawer, {
      preventDefaultEvents: true, 
      closeCallback: this._onCoverClosed, 
      open: true, 
      ref: 'coverCard', 
      className: className, 
      axis: 'x', 
      bounds: this.state.coverCardBounds, 
      touch: this.props.touch, 
      supportsCssTransforms3d: this.props.supportsCssTransforms3d
    }, 
      playersImages, 
      React.createElement("div", {className: "text-wrapper"}, 
        React.createElement("div", {className: "text"}, 
          React.createElement("a", {className: "logo", href: "http://bleacherreport.com/"}, 
            React.createElement("img", {src: "assets/image/logo/br-logo-white.png"})
          ), 
          React.createElement("div", {className: "presented-by"}), 
          React.createElement("div", {className: "header"}, 
            React.createElement("h1", null, "NBA"), 
            React.createElement("h2", null, "ALL-STAR"), 
            React.createElement("h3", null, "LINEUP GENERATOR")
          )
        ), 
        React.createElement("div", {className: "enter-cta"}, 
          React.createElement("div", {className: "cta-wrapper"}, 
            React.createElement("div", {className: "cta-l l1"}, actionText, " BALL")
          ), 
          React.createElement(BallButton, {
            touch: this.props.touch, 
            touchEndHandler: this._onCoverEnterClick}
          ), 
          React.createElement("div", {className: "cta-wrapper"}, 
            React.createElement("div", {className: "cta-l l2"}, "TO START")
          )
        )
      )
    ));
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  _renderPlayerImages() {
    const randomInts = this.randomPLayerInts;
    const bottomPlayerImages = [
      data.players[randomInts[0]].image,
      data.players[randomInts[1]].image,
    ];
    const topPlayerImages = [
      data.players[randomInts[2]].image,
      data.players[randomInts[3]].image,
    ];

    return (
      React.createElement("div", {className: "players-images"}, 
        React.createElement("div", {className: "bottom"}, 
          React.createElement(ImageLoader, {
            className: "left", 
            src: this.imagePath + '/large/' + bottomPlayerImages[0]}
          ), 
          React.createElement(ImageLoader, {
            className: "right", 
            src: this.imagePath + '/large/' + bottomPlayerImages[1]}
          )
        ), 
        React.createElement("div", {className: "top"}, 
          React.createElement(ImageLoader, {
            className: "left", 
            src: this.imagePath + '/large/' + topPlayerImages[0]}
          ), 
          React.createElement(ImageLoader, {
            className: "right", 
            src: this.imagePath + '/large/' + topPlayerImages[1]}
          )
        )
      )
    );
  },


  /**
   * Renders the secondary info drawer
   * @returns {Object} React element
   */
  _renderSortInfo() {
    const infoHeaderAnimateClass = this.state.animateOutInfoHeader ?
      ' animate-out' : '';
    const showInfoClass = this.state.showInfo ? ' show' : '';
    const text = this.state.sortCategory ? this.state.sortCategory.text : null;
    const imageClass = (this.state.sortCategory && this.state.sortCategory.image) ?
      ' image' : ' no-image';
    const textClass = text ? ' text' : ' no-text';
    const className = 'sort-info' +
      infoHeaderAnimateClass +
      showInfoClass +
      imageClass +
      textClass;
    let imageElement;
    let textElement;

    if (this.state.sortImage) {
      imageElement = (
        React.createElement("div", {className: "image"}, 
          React.createElement("img", {src: this.state.sortImage})
        )
      );
    }

    if (text) {
      textElement = (
        React.createElement("div", {className: "text"}, text)
      );
    }

    return (
      React.createElement("div", {className: className}, 
        React.createElement("div", {className: "top-border"}), 
        React.createElement("div", {className: "text-wrapper"}, 
          imageElement, 
          textElement
        ), 
        React.createElement("div", {className: "footer"}, 
          React.createElement("a", {className: "logo", href: "http://bleacherreport.com/"}, 
            React.createElement("img", {src: "assets/image/logo/br-logo-white.png"})
          ), 
          React.createElement("ul", {className: "credits"}, 
            React.createElement("li", null, "illustrations MATTHEW HOLLISTER"), 
            React.createElement("li", null, "editor CHRIS TRENCHARD"), 
            React.createElement("li", null, "produced by MIKE FEY & DYLAN LATHROP")
          )
        )
      )
    );
  },


  /**
   * Renders the info graphic for the current sort
   * @returns {ReactElement} A React element
   */
  _renderSortImage() {
    return this.state.sortCategory ? this.state.sortCategory.image : null;
  },


  /**
   * Sets the cover card bounds
   * @returns {undefined} undefined
   */
  _setCoverCardBounds() {
    const bounds = {
      x1: -this.state.windowSize.width,
      y1: 0,
      x2: 0,
      y2: this.state.windowSize.height,
    };

    this.setState({ coverCardBounds: bounds });
  },


  /**
   * Animates in cover card content
   * @returns {undefined} undefined
   */
  _doIntro() {
    const _this = this;

    setTimeout(function () {
      _this.setState({ showCover: true });
    }, 10);

    setTimeout(function () {
      _this.setState({
        animateCoverBall: true,
      });
    }, 210);

    setTimeout(function () {
      _this.setState({
        showContent: true,
      });
    }, 300);

    setTimeout(function () {
      _this.setState({ animateCoverCta: true });
    }, 500);

    setTimeout(function () {
      _this.setState({ animateCoverPlayers: true });
    }, 1100);
  },


  /**
   * Called when a CHANGE event is emitted from the ResizerStore
   * @returns {undefined} undefined
   */
  _onResizerChange() {
    const _this = this;

    this.setState(ResizerStore.getState(), function () {
      _this._setCoverCardBounds();
    });
  },


  /**
   * Called when a CHANGE event is emitted from the TeamsStore
   * @returns {undefined} undefined
   */
  _onTeamsChange() {
    const _this = this;
    clearTimeout(this.animateInInfoHeaderTimeout);
    clearTimeout(this.showSortImageTimeout);

    this.setState({ animateOutInfoHeader: true });

    this.animateInInfoHeaderTimeout = setTimeout(function () {
      const teamsState = Object.assign({}, TeamsStore.getState());
      let showDescription = this.descriptionHidden ? false : true;
      if (showDescription && teamsState.sortCategory.id !== 0) {
        showDescription = false;
        this.descriptionHidden = true;
      }

      const newState = Object.assign(teamsState, {
        animateOutInfoHeader: false,
        sortImage: null,
        showDescription,
      });
      _this.setState(newState);
    }, 210);

    this.showSortImageTimeout = setTimeout(function () {
      _this.setState({ sortImage: _this._renderSortImage() });
    }, 700);
  },


  /**
   * 'Closes' the cover card
   * @returns {undefined} undefined
   */
  _onCoverEnterClick() {
    this.refs.coverCard._close();
  },


  /**
   * Callback for when the cover card is closed
   * @returns {undefined} undefined
   */
  _onCoverClosed() {
    const _this = this;

    setTimeout(function () {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.SHOW_TEAMS_HEADERS,
      });
    }, 210);

    setTimeout(function () {
      _this.setState({
        inIntro: false,
        showInfo: true,
      });

      AppDispatcher.handleViewAction({
        actionType: AppConstants.SHOW_TEAMS_SORT_BUTTON,
      });
    }, 500);
  },
});


export default NBAAllStarReconfigure;
